import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97a12872"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dispatcher" }
const _hoisted_2 = { class: "dispatcher__view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tabs = _resolveComponent("tabs")!
  const _component_sector_panel = _resolveComponent("sector-panel")!
  const _component_set_address_panel = _resolveComponent("set-address-panel")!
  const _component_map_geocoder = _resolveComponent("map-geocoder")!
  const _component_the_map = _resolveComponent("the-map")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tabs, {
      tabs: _ctx.ROUTES_TABS,
      disabled: _ctx.state.is_add_sector || Boolean(_ctx.state.sector)
    }, null, 8, ["tabs", "disabled"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_the_map, {
        onMapReady: _ctx.onMapReady,
        onMapChange: _ctx.onMapChange
      }, {
        default: _withCtx(() => [
          (_ctx.state.is_sector_panel_showed)
            ? (_openBlock(), _createBlock(_component_sector_panel, {
                key: 0,
                sector: _ctx.state.sector,
                "is-add-sector": _ctx.state.is_add_sector,
                "is-courier-sector": _ctx.state.sector_type === _ctx.COURIER_SECTOR_TYPE,
                "is-dispatcher-sector": _ctx.state.sector_type === _ctx.DISPATCHER_SECTOR_TYPE,
                loading: _ctx.state.is_sector_saving,
                "is-paint-started": _ctx.dispatcher_map.paint_state.is_started,
                "unfinished-sector": _ctx.state.unfinished_sector,
                onCancel: _ctx.stopSectorAction,
                onSave: _ctx.onSaveSector,
                onCreate: _ctx.onCreateSector,
                onStartPaint: _ctx.onStartPaint
              }, null, 8, ["sector", "is-add-sector", "is-courier-sector", "is-dispatcher-sector", "loading", "is-paint-started", "unfinished-sector", "onCancel", "onSave", "onCreate", "onStartPaint"]))
            : _createCommentVNode("", true),
          (_ctx.dispatcher_map.setting_address_state.is_setting)
            ? (_openBlock(), _createBlock(_component_set_address_panel, {
                key: 1,
                "order-id": _ctx.dispatcher_map.setting_address_state.order.id,
                address: _ctx.dispatcher_map.setting_address_state.new_address,
                "address-loading": _ctx.dispatcher_map.setting_address_state.is_geocoding,
                loading: _ctx.dispatcher_map.setting_address_state.is_saving,
                onCancel: _ctx.onCancelSetAddress,
                onSave: _ctx.onSaveAddress
              }, null, 8, ["order-id", "address", "address-loading", "loading", "onCancel", "onSave"]))
            : _createCommentVNode("", true),
          (_ctx.dispatcher_map.setting_address_state.is_setting)
            ? (_openBlock(), _createBlock(_component_map_geocoder, {
                key: 2,
                "twogis-geocoder": _ctx.dispatcher_map.state.map_type === _ctx.TWO_GIS_MAP_TYPE,
                "yandex-geocoder": _ctx.dispatcher_map.state.map_type === _ctx.YANDEX_MAP_TYPE,
                onSelect: _ctx.onSelectAddress
              }, null, 8, ["twogis-geocoder", "yandex-geocoder", "onSelect"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onMapReady", "onMapChange"]),
      _createVNode(_component_router_view, { class: "mt-6" })
    ])
  ]))
}